import { cn } from '@/lib/utils'

interface ICardWrapperProps {
  children: React.ReactNode
  className?: string
}

export function CardWrapper({ children, className }: ICardWrapperProps) {
  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-between px-4 pt-8 md:flex-row md:gap-4 md:px-8',
        className
      )}
    >
      {children}
    </div>
  )
}
